import { API_BASE } from 'consts'
import { Analytics } from 'common-frontend'

export default class ChargeUtils {
  static upgrade(accessToken, pageLocation) {
    Analytics.track("'Upgrade' Button Clicked", { page_location: pageLocation })

    let form = document.createElement('form')
    form.method = 'POST'
    form.action = `${API_BASE}/charges`
    form.style  = 'position: relative; left: -9999px;'

    let input = document.createElement('input')
    input.type  = 'hidden'
    input.name  = 'access_token'
    input.value = accessToken
    form.appendChild(input)

    let button = document.createElement('input')
    button.setAttribute('type', 'submit')
    form.appendChild(button)

    document.getElementsByTagName('body')[0].appendChild(form) // be sure to test in Firefox, as it has quirks around dynamically created forms
    form.submit()
  }
}



// WEBPACK FOOTER //
// ./app/utils/ChargeUtils.js